import { Check } from 'lucide-react';
import { cn } from '../../lib/cn';

/** Case à cocher façon Keep (carré gris, coche sombre). */
export function Checkbox({
  checked,
  onChange,
  label,
  className,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  className?: string;
}) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      aria-label={label}
      onClick={(event) => {
        event.stopPropagation();
        onChange(!checked);
      }}
      className={cn(
        'flex size-[18px] shrink-0 items-center justify-center rounded-[2px] border-2 border-muted/80 text-fg transition-colors',
        'hover:border-fg focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary',
        className,
      )}
    >
      {checked && <Check size={14} strokeWidth={3} aria-hidden />}
    </button>
  );
}
